import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import type { ShellMarca } from '@intelishs-group/layout';
import { BackToTop, FileViewer } from '@intelishs-group/ui';

/**
 * El nombre visible del sistema: el mismo que el `<title>` de `index.html`. Lo pinta el marco de
 * SINAY (`components/marco`), que es la ruta padre de todas las pantallas.
 */
export const MARCA: ShellMarca = { nombre: 'SINAY · Nómina' };

/**
 * Raiz de composicion: el router y los dos globales de la plataforma (visor de archivos y volver
 * arriba). El marco (`<intelishs-shell-sesion>`) no se monta aqui: es la ruta padre de
 * `app.routes.ts`. La sesion la carga `proveerSesion` (`app.config.ts`) antes del primer render.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FileViewer, BackToTop],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
